import React from 'react';
import * as Styled from './style';

interface Props {
  data: {
    lawTypes: string;
    serviceAreas: string;
    excludedCases: string;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  errors: {
    lawTypes?: string;
    serviceAreas?: string;
    excludedCases?: string;
  };
   setErrors: React.Dispatch<React.SetStateAction<any>>;
      handleChange: (
        e:
          | React.ChangeEvent<HTMLInputElement>
          | React.ChangeEvent<HTMLTextAreaElement>
          | React.ChangeEvent<HTMLSelectElement>
      ) => void;
      handleBlur: (
        e:
          | React.ChangeEvent<HTMLInputElement>
          | React.ChangeEvent<HTMLTextAreaElement>
          | React.ChangeEvent<HTMLSelectElement>
      ) => void;

  handleNext: () => void;
  handleBack: () => void;
}

export default function StepFour({
  data,
  setFormData,
  errors,
  handleChange,
  handleNext,
  handleBack,
}: Props) {
  return (
    <>
      <Styled.Title>Legal Services</Styled.Title>

      <Styled.Group>
        <Styled.Label>
          What type(s) of law does your firm handle?
          <Styled.HelperText>
            (Include any specialties or focus areas you want the chatbot to emphasize)
          </Styled.HelperText>
        </Styled.Label>
        <Styled.Textarea
          name="lawTypes"
          value={data.lawTypes}
          onChange={handleChange}
        />
        {errors.lawTypes && <Styled.Error>{errors.lawTypes}</Styled.Error>}
      </Styled.Group>

      <Styled.Group>
        <Styled.Label>
          What cities, counties, or geographic areas do you provide service in?
        </Styled.Label>
        <Styled.Textarea
          name="serviceAreas"
          value={data.serviceAreas}
          onChange={handleChange}
        />
        {errors.serviceAreas && <Styled.Error>{errors.serviceAreas}</Styled.Error>}
      </Styled.Group>

      <Styled.Group>
        <Styled.Label>
          Are there any types of law or cases your firm does not handle?
          <Styled.HelperText>
            (Explain any disqualifiers or case types to filter out)
          </Styled.HelperText>
        </Styled.Label>
        <Styled.Textarea
          name="excludedCases"
          value={data.excludedCases}
          onChange={handleChange}
        />
        {errors.excludedCases && <Styled.Error>{errors.excludedCases}</Styled.Error>}
      </Styled.Group>

      <Styled.ButtonGroup>
        <Styled.Button type="button" onClick={handleBack}>Go back</Styled.Button>
        <Styled.Button type="button" onClick={handleNext}>
          Next step: payment & consultation info →
        </Styled.Button>
      </Styled.ButtonGroup>
    </>
  );
}
